module.exports = "mutation ($data: OpenhouseCreate!) {\n  OpenhouseCreate(data: $data) {\n    id\n  }\n}\n"